import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Fix ResizeObserver loop error that occurs with Radix UI components
// This patches the ResizeObserver to debounce and prevent the loop warning
const debounce = (callback, delay) => {
  let tid;
  return function (...args) {
    const ctx = this;
    clearTimeout(tid);
    tid = setTimeout(() => callback.apply(ctx, args), delay);
  };
};

const _ = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ {
  constructor(callback) {
    super(debounce(callback, 20));
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
